// Payroll Actions
export const FETCH_EXTRA_PAYMENT_PAYROLL_REQUEST = 'FETCH_EXTRA_PAYMENT_PAYROLL_REQUEST';
export const FETCH_EXTRA_PAYMENT_PAYROLL_SUCCESS = 'FETCH_EXTRA_PAYMENT_PAYROLL_SUCCESS';
export const FETCH_EXTRA_PAYMENT_PAYROLL_FAILURE = 'FETCH_EXTRA_PAYMENT_PAYROLL_FAILURE';

export const SAVE_PAYROLL_REQUEST = 'SAVE_PAYROLL_REQUEST';
export const SAVE_PAYROLL_SUCCESS = 'SAVE_PAYROLL_SUCCESS';
export const SAVE_PAYROLL_FAILURE = 'SAVE_PAYROLL_FAILURE';

export const CHANGE_PAYROLL_STATUS_REQUEST = 'CHANGE_PAYROLL_STATUS_REQUEST';
export const CHANGE_PAYROLL_STATUS_SUCCESS = 'CHANGE_PAYROLL_STATUS_SUCCESS';
export const CHANGE_PAYROLL_STATUS_FAILURE = 'CHANGE_PAYROLL_STATUS_FAILURE';
